export function showProbability(prob) {
    const ret = (prob * 100).toFixed(2);
    if (ret === "0.00")
        return "< 0.01%";
    return ret + "%";
}
export function multimap(entries) {
    var _a;
    let ret = new Map();
    for (const [k, v] of entries) {
        const list = (_a = ret.get(k)) !== null && _a !== void 0 ? _a : [];
        list.push(v);
        ret.set(k, list);
    }
    return ret;
}
